import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_TATTOO } from "../../lib/constants";

export const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={WA_TATTOO}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label="Falar com a Diggy Shop no WhatsApp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-[80] group"
        >
          <span className="absolute inset-0 rounded-full bg-[#E60000] animate-ping opacity-30" />
          <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#E60000] shadow-[0_10px_40px_rgba(230,0,0,0.45)] group-hover:bg-white transition-colors duration-300">
            <MessageCircle size={24} className="text-white group-hover:text-[#E60000] transition-colors duration-300" fill="currentColor" />
          </span>
          <span className="hidden md:block absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#171717] border border-white/10 text-white text-xs tracking-[0.15em] font-bold px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            FALE COM A DIGGY
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
